import React, { Component } from 'react';
import Navbar from './mycomponents/navbar';
import ViewMyGroupListBody from './mycomponents/viewmygrouplistbody';
import PalmeeupIcon from './mycomponents/palmeeupbuttonicon';

class ViewMyGroupList extends Component {
    state = {  } 
    render() { 
        return (
            <React.Fragment>
            <Navbar/>
            <ViewMyGroupListBody />
            <PalmeeupIcon/>
                </React.Fragment>
        );
    }
}
 
export default ViewMyGroupList;